<template>
  <layout-apply-cancel @cancel="cancel" @apply="applyClick" />
</template>

<script>
/** (GW)
 * Asset Editor's credits apply cancel (top bar)
 * Emits apply event to parent assetEditorVue
 * Dispatches changeCurrentEffect
 */
import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import PageMixin from 'AssetEditor/pages/PageMixin.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  mixins: [PageMixin],

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage']),

    cancel: function () {
      this.changeCurrentPage('preview');
    },

    backToPreview() {
      this.askSaveChanges(this.isTempAgdDirty);
    },

    /**
     * Emit apply event
     * caught by assetEditorVue's active child component
     */
    applyClick: function () {
      bus.$emit('apply-click');
      this.changeCurrentPage('preview');
    },
  },
};
</script>
